import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Authentication } from '../../services/authentication.service';
import { ErrorHandlingService } from '../../services/error-handling.service';
import { NotificationService } from '../../services/notification.service';
import { AccountService } from '../../services/account.service';
import { TitleService } from '../../services/title.service';

@Component({
  standalone: false,
  selector: 'app-email-reset-password',
  templateUrl: './email-reset-password.component.html',
  styleUrls: ['./email-reset-password.component.css'],
})
export class EmailResetPasswordComponent implements OnInit {
  isAdd = false;

  userName: any;

  constructor(
    private authService: Authentication,
    private accountService: AccountService,
    private router: Router,
    private route: ActivatedRoute,
    private ngxLoader: NgxUiLoaderService,
    private errorHandlingService: ErrorHandlingService,
    private notificationService: NotificationService,
    private titleService: TitleService,
  ) {
    if (this.authService.isTokenValid()) {
      this.router.navigate(['dashboard']);
    }
  }

  resendPasswordResetEmail(): any {
    this.ngxLoader.start();
    const localuser = this.userName;
    this.accountService.reset(this.userName.toLowerCase()).subscribe(
      (data) => {
        this.ngxLoader.stop();
        this.notificationService.showSuccess(`Reset Password email resent to ${localuser}`);
      },
      (err) => {
        this.ngxLoader.stop();
        return this.errorHandlingService.handleError(err, err.url);
      },
    );
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.route.snapshot, this.router.routerState.snapshot);
    this.route.queryParams.subscribe((params) => {
      this.userName = params['username'];
    });
  }

  navigate() {
    window.location.href = 'https://www.terminologyhub.com';
  }
}
